export const ui = {
	en:{
		siteTitle:`Le Chat`,
		slogan: 'website live chat with a mobile app',
	},
	jp:{
		siteTitle:`Le Chat`,
		slogan: 'モバイルアプリを使ったウェブチャット',
	}
}